import _get from "/var/www/html/git/naati_pte/web_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/var/www/html/git/naati_pte/web_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _slicedToArray from "/var/www/html/git/naati_pte/web_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _possibleConstructorReturn from "/var/www/html/git/naati_pte/web_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _inherits from "/var/www/html/git/naati_pte/web_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/var/www/html/git/naati_pte/web_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _classCallCheck from "/var/www/html/git/naati_pte/web_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/html/git/naati_pte/web_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _createForOfIteratorHelper from "/var/www/html/git/naati_pte/web_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function t(t, e, i, s) {
  return new (i || (i = Promise))(function (n, r) {
    function o(t) {
      try {
        h(s.next(t));
      } catch (t) {
        r(t);
      }
    }
    function a(t) {
      try {
        h(s.throw(t));
      } catch (t) {
        r(t);
      }
    }
    function h(t) {
      var e;
      t.done ? n(t.value) : (e = t.value, e instanceof i ? e : new i(function (t) {
        t(e);
      })).then(o, a);
    }
    h((s = s.apply(t, e || [])).next());
  });
}
"function" == typeof SuppressedError && SuppressedError;
var e = {
  decode: function decode(e, i) {
    return t(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var t, s;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            t = new AudioContext({
              sampleRate: i
            }), s = t.decodeAudioData(e);
            return _context.abrupt("return", (s.finally(function () {
              return t.close();
            }), s));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  },
  createBuffer: function createBuffer(t, e) {
    return "number" == typeof t[0] && (t = [t]), function (t) {
      var e = t[0];
      if (e.some(function (t) {
        return t > 1 || t < -1;
      })) {
        var _i = e.length;
        var _s = 0;
        for (var _t = 0; _t < _i; _t++) {
          var _i2 = Math.abs(e[_t]);
          _i2 > _s && (_s = _i2);
        }
        var _iterator = _createForOfIteratorHelper(t),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _e = _step.value;
            for (var _t2 = 0; _t2 < _i; _t2++) _e[_t2] /= _s;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }(t), {
      duration: e,
      length: t[0].length,
      sampleRate: t[0].length / e,
      numberOfChannels: t.length,
      getChannelData: function getChannelData(e) {
        return null == t ? void 0 : t[e];
      },
      copyFromChannel: AudioBuffer.prototype.copyFromChannel,
      copyToChannel: AudioBuffer.prototype.copyToChannel
    };
  }
};
var i = {
  fetchBlob: function fetchBlob(e, i) {
    return t(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", fetch(e, i).then(function (t) {
              return t.blob();
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  }
};
var s = /*#__PURE__*/function () {
  function s() {
    _classCallCheck(this, s);
    this.listeners = {};
  }
  _createClass(s, [{
    key: "on",
    value: function on(t, e) {
      var _this = this;
      return this.listeners[t] || (this.listeners[t] = new Set()), this.listeners[t].add(e), function () {
        return _this.un(t, e);
      };
    }
  }, {
    key: "once",
    value: function once(t, e) {
      var i = this.on(t, e),
        _s2 = this.on(t, function () {
          i(), _s2();
        });
      return i;
    }
  }, {
    key: "un",
    value: function un(t, e) {
      this.listeners[t] && (e ? this.listeners[t].delete(e) : delete this.listeners[t]);
    }
  }, {
    key: "unAll",
    value: function unAll() {
      this.listeners = {};
    }
  }, {
    key: "emit",
    value: function emit(t) {
      for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        e[_key - 1] = arguments[_key];
      }
      this.listeners[t] && this.listeners[t].forEach(function (t) {
        return t.apply(void 0, e);
      });
    }
  }]);
  return s;
}();
var n = /*#__PURE__*/function (_s3) {
  _inherits(n, _s3);
  var _super = _createSuper(n);
  function n(t) {
    var _this2;
    _classCallCheck(this, n);
    _this2 = _super.call(this), t.media ? _this2.media = t.media : _this2.media = document.createElement("audio"), t.autoplay && (_this2.media.autoplay = !0), null != t.playbackRate && (_this2.media.playbackRate = t.playbackRate);
    return _this2;
  }
  _createClass(n, [{
    key: "onMediaEvent",
    value: function onMediaEvent(t, e, i) {
      var _this3 = this;
      return this.media.addEventListener(t, e, i), function () {
        return _this3.media.removeEventListener(t, e);
      };
    }
  }, {
    key: "onceMediaEvent",
    value: function onceMediaEvent(t, e) {
      return this.onMediaEvent(t, e, {
        once: !0
      });
    }
  }, {
    key: "getSrc",
    value: function getSrc() {
      return this.media.currentSrc || this.media.src || "";
    }
  }, {
    key: "revokeSrc",
    value: function revokeSrc() {
      var t = this.getSrc();
      t.startsWith("blob:") && URL.revokeObjectURL(t);
    }
  }, {
    key: "setSrc",
    value: function setSrc(t, e) {
      if (this.getSrc() === t) return;
      this.revokeSrc();
      var i = e instanceof Blob ? URL.createObjectURL(e) : t;
      this.media.src = i, this.media.load();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.media.pause(), this.revokeSrc(), this.media.src = "", this.media.load();
    }
  }, {
    key: "play",
    value: function play() {
      return this.media.play();
    }
  }, {
    key: "pause",
    value: function pause() {
      this.media.pause();
    }
  }, {
    key: "isPlaying",
    value: function isPlaying() {
      return this.media.currentTime > 0 && !this.media.paused && !this.media.ended;
    }
  }, {
    key: "setTime",
    value: function setTime(t) {
      this.media.currentTime = t;
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.media.duration;
    }
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.media.currentTime;
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.media.volume;
    }
  }, {
    key: "setVolume",
    value: function setVolume(t) {
      this.media.volume = t;
    }
  }, {
    key: "getMuted",
    value: function getMuted() {
      return this.media.muted;
    }
  }, {
    key: "setMuted",
    value: function setMuted(t) {
      this.media.muted = t;
    }
  }, {
    key: "getPlaybackRate",
    value: function getPlaybackRate() {
      return this.media.playbackRate;
    }
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(t, e) {
      null != e && (this.media.preservesPitch = e), this.media.playbackRate = t;
    }
  }, {
    key: "getMediaElement",
    value: function getMediaElement() {
      return this.media;
    }
  }, {
    key: "setSinkId",
    value: function setSinkId(t) {
      return this.media.setSinkId(t);
    }
  }]);
  return n;
}(s);
var r = /*#__PURE__*/function (_s4) {
  _inherits(r, _s4);
  var _super2 = _createSuper(r);
  function r(t) {
    var _this4;
    _classCallCheck(this, r);
    var e;
    if (_this4 = _super2.call(this), _this4.timeouts = [], _this4.isScrolling = !1, _this4.audioData = null, _this4.resizeObserver = null, _this4.isDragging = !1, _this4.options = t, "string" == typeof t.container ? e = document.querySelector(t.container) : t.container instanceof HTMLElement && (e = t.container), !e) throw new Error("Container not found");
    _this4.parent = e;
    var _this4$initHtml = _this4.initHtml(),
      _this4$initHtml2 = _slicedToArray(_this4$initHtml, 2),
      i = _this4$initHtml2[0],
      s = _this4$initHtml2[1];
    e.appendChild(i), _this4.container = i, _this4.scrollContainer = s.querySelector(".scroll"), _this4.wrapper = s.querySelector(".wrapper"), _this4.canvasWrapper = s.querySelector(".canvases"), _this4.progressWrapper = s.querySelector(".progress"), _this4.cursor = s.querySelector(".cursor"), _this4.initEvents();
    return _possibleConstructorReturn(_this4);
  }
  _createClass(r, [{
    key: "initEvents",
    value: function initEvents() {
      var _this5 = this;
      this.wrapper.addEventListener("click", function (t) {
        var e = _this5.wrapper.getBoundingClientRect(),
          i = (t.clientX - e.left) / e.width;
        _this5.emit("click", i);
      }), this.initDrag(), this.scrollContainer.addEventListener("scroll", function () {
        var _this5$scrollContaine = _this5.scrollContainer,
          t = _this5$scrollContaine.scrollLeft,
          e = _this5$scrollContaine.scrollWidth,
          i = _this5$scrollContaine.clientWidth,
          s = t / e,
          n = (t + i) / e;
        _this5.emit("scroll", s, n);
      });
      var t = this.createDelay(100);
      this.resizeObserver = new ResizeObserver(function () {
        t(function () {
          return _this5.reRender();
        });
      }), this.resizeObserver.observe(this.scrollContainer);
    }
  }, {
    key: "initDrag",
    value: function initDrag() {
      var _this6 = this;
      !function (t, e, i, s) {
        var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 5;
        var r = function r() {};
        if (!t) return r;
        var o = function o(_o) {
          if (2 === _o.button) return;
          _o.preventDefault(), _o.stopPropagation();
          var a = _o.clientX,
            h = _o.clientY,
            l = !1;
          var c = function c(s) {
              s.preventDefault(), s.stopPropagation();
              var r = s.clientX,
                o = s.clientY;
              if (l || Math.abs(r - a) >= n || Math.abs(o - h) >= n) {
                var _t$getBoundingClientR = t.getBoundingClientRect(),
                  _s5 = _t$getBoundingClientR.left,
                  _n = _t$getBoundingClientR.top;
                l || (l = !0, null == i || i(a - _s5, h - _n)), e(r - a, o - h, r - _s5, o - _n), a = r, h = o;
              }
            },
            d = function d(t) {
              l && (t.preventDefault(), t.stopPropagation());
            },
            u = function u() {
              l && (null == s || s()), r();
            };
          document.addEventListener("pointermove", c), document.addEventListener("pointerup", u), document.addEventListener("pointerleave", u), document.addEventListener("click", d, !0), r = function r() {
            document.removeEventListener("pointermove", c), document.removeEventListener("pointerup", u), document.removeEventListener("pointerleave", u), setTimeout(function () {
              document.removeEventListener("click", d, !0);
            }, 10);
          };
        };
        t.addEventListener("pointerdown", o);
      }(this.wrapper, function (t, e, i) {
        _this6.emit("drag", Math.max(0, Math.min(1, i / _this6.wrapper.clientWidth)));
      }, function () {
        return _this6.isDragging = !0;
      }, function () {
        return _this6.isDragging = !1;
      });
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return null == this.options.height ? 128 : isNaN(Number(this.options.height)) ? "auto" === this.options.height && this.parent.clientHeight || 128 : Number(this.options.height);
    }
  }, {
    key: "initHtml",
    value: function initHtml() {
      var t = document.createElement("div"),
        e = t.attachShadow({
          mode: "open"
        });
      return e.innerHTML = "\n      <style>\n        :host {\n          user-select: none;\n        }\n        :host .scroll {\n          overflow-x: auto;\n          overflow-y: hidden;\n          width: 100%;\n          position: relative;\n          touch-action: none;\n        }\n        :host .noScrollbar {\n          scrollbar-color: transparent;\n          scrollbar-width: none;\n        }\n        :host .noScrollbar::-webkit-scrollbar {\n          display: none;\n          -webkit-appearance: none;\n        }\n        :host .wrapper {\n          position: relative;\n          overflow: visible;\n          z-index: 2;\n        }\n        :host .canvases {\n          min-height: ".concat(this.getHeight(), "px;\n        }\n        :host .canvases > div {\n          position: relative;\n        }\n        :host canvas {\n          display: block;\n          position: absolute;\n          top: 0;\n          image-rendering: pixelated;\n        }\n        :host .progress {\n          pointer-events: none;\n          position: absolute;\n          z-index: 2;\n          top: 0;\n          left: 0;\n          width: 0;\n          height: 100%;\n          overflow: hidden;\n        }\n        :host .progress > div {\n          position: relative;\n        }\n        :host .cursor {\n          pointer-events: none;\n          position: absolute;\n          z-index: 5;\n          top: 0;\n          left: 0;\n          height: 100%;\n          border-radius: 2px;\n        }\n      </style>\n\n      <div class=\"scroll\" part=\"scroll\">\n        <div class=\"wrapper\">\n          <div class=\"canvases\"></div>\n          <div class=\"progress\" part=\"progress\"></div>\n          <div class=\"cursor\" part=\"cursor\"></div>\n        </div>\n      </div>\n    "), [t, e];
    }
  }, {
    key: "setOptions",
    value: function setOptions(t) {
      this.options = t, this.reRender();
    }
  }, {
    key: "getWrapper",
    value: function getWrapper() {
      return this.wrapper;
    }
  }, {
    key: "getScroll",
    value: function getScroll() {
      return this.scrollContainer.scrollLeft;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var t;
      this.container.remove(), null === (t = this.resizeObserver) || void 0 === t || t.disconnect();
    }
  }, {
    key: "createDelay",
    value: function createDelay() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
      var e = {};
      return this.timeouts.push(e), function (i) {
        e.timeout && clearTimeout(e.timeout), e.timeout = setTimeout(i, t);
      };
    }
  }, {
    key: "convertColorValues",
    value: function convertColorValues(t) {
      if (!Array.isArray(t)) return t || "";
      if (t.length < 2) return t[0] || "";
      var e = document.createElement("canvas"),
        i = e.getContext("2d").createLinearGradient(0, 0, 0, e.height),
        s = 1 / (t.length - 1);
      return t.forEach(function (t, e) {
        var n = e * s;
        i.addColorStop(n, t);
      }), i;
    }
  }, {
    key: "renderBars",
    value: function renderBars(t, e, i) {
      if (i.fillStyle = this.convertColorValues(e.waveColor), e.renderFunction) return void e.renderFunction(t, i);
      var s = t[0],
        n = t[1] || t[0],
        _r = s.length,
        o = window.devicePixelRatio || 1,
        _i$canvas = i.canvas,
        a = _i$canvas.width,
        h = _i$canvas.height,
        l = h / 2,
        c = e.barHeight || 1,
        d = e.barWidth ? e.barWidth * o : 1,
        u = e.barGap ? e.barGap * o : e.barWidth ? d / 2 : 0,
        p = e.barRadius || 0,
        m = a / (d + u) / _r;
      var g = 1;
      if (e.normalize) {
        g = 0;
        for (var _t3 = 0; _t3 < _r; _t3++) {
          var _e2 = Math.abs(s[_t3]);
          _e2 > g && (g = _e2);
        }
      }
      var v = l / g * c,
        f = p && "roundRect" in i ? "roundRect" : "rect";
      i.beginPath();
      var b = 0,
        y = 0,
        C = 0;
      for (var _t4 = 0; _t4 <= _r; _t4++) {
        var _r2 = Math.round(_t4 * m);
        if (_r2 > b) {
          var _t5 = Math.round(y * v),
            _s6 = _t5 + Math.round(C * v) || 1;
          var _n2 = l - _t5;
          "top" === e.barAlign ? _n2 = 0 : "bottom" === e.barAlign && (_n2 = h - _s6), i[f](b * (d + u), _n2, d, _s6, p), b = _r2, y = 0, C = 0;
        }
        var _o2 = Math.abs(s[_t4] || 0),
          _a = Math.abs(n[_t4] || 0);
        _o2 > y && (y = _o2), _a > C && (C = _a);
      }
      i.fill(), i.closePath();
    }
  }, {
    key: "renderSingleCanvas",
    value: function renderSingleCanvas(t, e, i, s, n, _r3, o, a) {
      var h = window.devicePixelRatio || 1,
        l = document.createElement("canvas"),
        c = t[0].length;
      l.width = Math.round(i * (_r3 - n) / c), l.height = s * h, l.style.width = "".concat(Math.floor(l.width / h), "px"), l.style.height = "".concat(s, "px"), l.style.left = "".concat(Math.floor(n * i / h / c), "px"), o.appendChild(l);
      var d = l.getContext("2d");
      this.renderBars(t.map(function (t) {
        return t.slice(n, _r3);
      }), e, d);
      var u = l.cloneNode();
      a.appendChild(u);
      var p = u.getContext("2d");
      l.width > 0 && l.height > 0 && p.drawImage(l, 0, 0), p.globalCompositeOperation = "source-in", p.fillStyle = this.convertColorValues(e.progressColor), p.fillRect(0, 0, l.width, l.height);
    }
  }, {
    key: "renderWaveform",
    value: function renderWaveform(t, e, i) {
      var _this7 = this;
      var s = document.createElement("div"),
        n = this.getHeight();
      s.style.height = "".concat(n, "px"), this.canvasWrapper.style.minHeight = "".concat(n, "px"), this.canvasWrapper.appendChild(s);
      var o = s.cloneNode();
      this.progressWrapper.appendChild(o);
      var _this$scrollContainer = this.scrollContainer,
        a = _this$scrollContainer.scrollLeft,
        h = _this$scrollContainer.scrollWidth,
        l = _this$scrollContainer.clientWidth,
        c = t[0].length,
        d = c / h;
      var u = Math.min(r.MAX_CANVAS_WIDTH, l);
      if (e.barWidth || e.barGap) {
        var _t6 = e.barWidth || .5,
          _i3 = _t6 + (e.barGap || _t6 / 2);
        u % _i3 != 0 && (u = Math.floor(u / _i3) * _i3);
      }
      var p = Math.floor(Math.abs(a) * d),
        m = Math.floor(p + u * d),
        g = m - p,
        v = function v(_r4, a) {
          _this7.renderSingleCanvas(t, e, i, n, Math.max(0, _r4), Math.min(a, c), s, o);
        },
        f = this.createDelay(),
        b = this.createDelay(),
        y = function y(t, e) {
          v(t, e), t > 0 && f(function () {
            y(t - g, e - g);
          });
        },
        C = function C(t, e) {
          v(t, e), e < c && b(function () {
            C(t + g, e + g);
          });
        };
      y(p, m), m < c && C(m, m + g);
    }
  }, {
    key: "render",
    value: function render(t) {
      this.timeouts.forEach(function (t) {
        return t.timeout && clearTimeout(t.timeout);
      }), this.timeouts = [], this.canvasWrapper.innerHTML = "", this.progressWrapper.innerHTML = "", this.wrapper.style.width = "";
      var e = window.devicePixelRatio || 1,
        i = this.scrollContainer.clientWidth,
        s = Math.ceil(t.duration * (this.options.minPxPerSec || 0));
      this.isScrolling = s > i;
      var n = this.options.fillParent && !this.isScrolling,
        _r5 = (n ? i : s) * e;
      if (this.wrapper.style.width = n ? "100%" : "".concat(s, "px"), this.scrollContainer.style.overflowX = this.isScrolling ? "auto" : "hidden", this.scrollContainer.classList.toggle("noScrollbar", !!this.options.hideScrollbar), this.cursor.style.backgroundColor = "".concat(this.options.cursorColor || this.options.progressColor), this.cursor.style.width = "".concat(this.options.cursorWidth, "px"), this.options.splitChannels) for (var _e3 = 0; _e3 < t.numberOfChannels; _e3++) {
        var _i4 = Object.assign(Object.assign({}, this.options), this.options.splitChannels[_e3]);
        this.renderWaveform([t.getChannelData(_e3)], _i4, _r5);
      } else {
        var _e4 = [t.getChannelData(0)];
        t.numberOfChannels > 1 && _e4.push(t.getChannelData(1)), this.renderWaveform(_e4, this.options, _r5);
      }
      this.audioData = t, this.emit("render");
    }
  }, {
    key: "reRender",
    value: function reRender() {
      if (!this.audioData) return;
      var t = this.progressWrapper.clientWidth;
      this.render(this.audioData);
      var e = this.progressWrapper.clientWidth;
      this.scrollContainer.scrollLeft += e - t;
    }
  }, {
    key: "zoom",
    value: function zoom(t) {
      this.options.minPxPerSec = t, this.reRender();
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var _this$scrollContainer2 = this.scrollContainer,
        i = _this$scrollContainer2.clientWidth,
        s = _this$scrollContainer2.scrollLeft,
        n = _this$scrollContainer2.scrollWidth,
        _r6 = n * t,
        o = i / 2;
      if (_r6 > s + (e && this.options.autoCenter && !this.isDragging ? o : i) || _r6 < s) if (this.options.autoCenter && !this.isDragging) {
        var _t7 = o / 20;
        _r6 - (s + o) >= _t7 && _r6 < s + i ? this.scrollContainer.scrollLeft += _t7 : this.scrollContainer.scrollLeft = _r6 - o;
      } else if (this.isDragging) {
        var _t8 = 10;
        this.scrollContainer.scrollLeft = _r6 < s ? _r6 - _t8 : _r6 - i + _t8;
      } else this.scrollContainer.scrollLeft = _r6;
      {
        var _t9 = this.scrollContainer.scrollLeft,
          _e5 = _t9 / n,
          _s7 = (_t9 + i) / n;
        this.emit("scroll", _e5, _s7);
      }
    }
  }, {
    key: "renderProgress",
    value: function renderProgress(t, e) {
      isNaN(t) || (this.progressWrapper.style.width = 100 * t + "%", this.cursor.style.left = 100 * t + "%", this.cursor.style.marginLeft = 100 === Math.round(100 * t) ? "-".concat(this.options.cursorWidth, "px") : "", this.isScrolling && this.options.autoScroll && this.scrollIntoView(t, e));
    }
  }]);
  return r;
}(s);
r.MAX_CANVAS_WIDTH = 4e3;
var o = /*#__PURE__*/function (_s8) {
  _inherits(o, _s8);
  var _super3 = _createSuper(o);
  function o() {
    var _this8;
    _classCallCheck(this, o);
    _this8 = _super3.apply(this, arguments), _this8.unsubscribe = function () {};
    return _this8;
  }
  _createClass(o, [{
    key: "start",
    value: function start() {
      var _this9 = this;
      this.unsubscribe = this.on("tick", function () {
        requestAnimationFrame(function () {
          _this9.emit("tick");
        });
      }), this.emit("tick");
    }
  }, {
    key: "stop",
    value: function stop() {
      this.unsubscribe();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.unsubscribe();
    }
  }]);
  return o;
}(s);
var a = {
  waveColor: "#999",
  progressColor: "#555",
  cursorWidth: 1,
  minPxPerSec: 0,
  fillParent: !0,
  interact: !0,
  autoScroll: !0,
  autoCenter: !0,
  sampleRate: 8e3
};
var h = /*#__PURE__*/function (_n3) {
  _inherits(h, _n3);
  var _super4 = _createSuper(h);
  function h(t) {
    var _this10;
    _classCallCheck(this, h);
    var e, i;
    _this10 = _super4.call(this, {
      media: t.media,
      autoplay: t.autoplay,
      playbackRate: t.audioRate
    }), _this10.plugins = [], _this10.decodedData = null, _this10.duration = null, _this10.subscriptions = [], _this10.options = Object.assign({}, a, t), _this10.timer = new o(), _this10.renderer = new r(_this10.options), _this10.initPlayerEvents(), _this10.initRendererEvents(), _this10.initTimerEvents(), _this10.initPlugins();
    var s = _this10.options.url || (null === (e = _this10.options.media) || void 0 === e ? void 0 : e.currentSrc) || (null === (i = _this10.options.media) || void 0 === i ? void 0 : i.src);
    s && _this10.load(s, _this10.options.peaks, _this10.options.duration);
    return _this10;
  }
  _createClass(h, [{
    key: "setOptions",
    value: function setOptions(t) {
      this.options = Object.assign({}, this.options, t), this.renderer.setOptions(this.options), t.audioRate && this.setPlaybackRate(t.audioRate);
    }
  }, {
    key: "initTimerEvents",
    value: function initTimerEvents() {
      var _this11 = this;
      this.subscriptions.push(this.timer.on("tick", function () {
        var t = _this11.getCurrentTime();
        _this11.renderer.renderProgress(t / _this11.getDuration(), !0), _this11.emit("timeupdate", t), _this11.emit("audioprocess", t);
      }));
    }
  }, {
    key: "initPlayerEvents",
    value: function initPlayerEvents() {
      var _this12 = this;
      this.subscriptions.push(this.onMediaEvent("timeupdate", function () {
        var t = _this12.getCurrentTime();
        _this12.renderer.renderProgress(t / _this12.getDuration(), _this12.isPlaying()), _this12.emit("timeupdate", t);
      }), this.onMediaEvent("play", function () {
        _this12.emit("play"), _this12.timer.start();
      }), this.onMediaEvent("pause", function () {
        _this12.emit("pause"), _this12.timer.stop();
      }), this.onMediaEvent("ended", function () {
        _this12.emit("finish");
      }), this.onMediaEvent("seeking", function () {
        _this12.emit("seeking", _this12.getCurrentTime());
      }));
    }
  }, {
    key: "initRendererEvents",
    value: function initRendererEvents() {
      var _this13 = this;
      this.subscriptions.push(this.renderer.on("click", function (t) {
        _this13.options.interact && (_this13.seekTo(t), _this13.emit("interaction", _this13.getCurrentTime()), _this13.emit("click", t));
      }), this.renderer.on("scroll", function (t, e) {
        var i = _this13.getDuration();
        _this13.emit("scroll", t * i, e * i);
      }), this.renderer.on("render", function () {
        _this13.emit("redraw");
      }));
      {
        var _t10;
        this.subscriptions.push(this.renderer.on("drag", function (e) {
          _this13.options.interact && (_this13.renderer.renderProgress(e), clearTimeout(_t10), _t10 = setTimeout(function () {
            _this13.seekTo(e);
          }, _this13.isPlaying() ? 0 : 200), _this13.emit("interaction", e * _this13.getDuration()), _this13.emit("drag", e));
        }));
      }
    }
  }, {
    key: "initPlugins",
    value: function initPlugins() {
      var _this14 = this;
      var t;
      (null === (t = this.options.plugins) || void 0 === t ? void 0 : t.length) && this.options.plugins.forEach(function (t) {
        _this14.registerPlugin(t);
      });
    }
  }, {
    key: "registerPlugin",
    value: function registerPlugin(t) {
      var _this15 = this;
      return t.init(this), this.plugins.push(t), this.subscriptions.push(t.once("destroy", function () {
        _this15.plugins = _this15.plugins.filter(function (e) {
          return e !== t;
        });
      })), t;
    }
  }, {
    key: "getWrapper",
    value: function getWrapper() {
      return this.renderer.getWrapper();
    }
  }, {
    key: "getScroll",
    value: function getScroll() {
      return this.renderer.getScroll();
    }
  }, {
    key: "getActivePlugins",
    value: function getActivePlugins() {
      return this.plugins;
    }
  }, {
    key: "load",
    value: function load(s, n, r) {
      return t(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this16 = this;
        var t, _i5;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.isPlaying() && this.pause(), this.decodedData = null, this.duration = null, this.emit("load", s);
              if (!n) {
                _context3.next = 5;
                break;
              }
              _context3.t0 = void 0;
              _context3.next = 8;
              break;
            case 5:
              _context3.next = 7;
              return i.fetchBlob(s, this.options.fetchParams);
            case 7:
              _context3.t0 = _context3.sent;
            case 8:
              t = _context3.t0;
              this.setSrc(s, t);
              _context3.t2 = r || this.getDuration();
              if (_context3.t2) {
                _context3.next = 15;
                break;
              }
              _context3.next = 14;
              return new Promise(function (t) {
                _this16.onceMediaEvent("loadedmetadata", function () {
                  return t(_this16.getDuration());
                });
              });
            case 14:
              _context3.t2 = _context3.sent;
            case 15:
              _context3.t1 = _context3.t2;
              if (_context3.t1) {
                _context3.next = 18;
                break;
              }
              _context3.t1 = 0;
            case 18:
              this.duration = _context3.t1;
              if (!n) {
                _context3.next = 23;
                break;
              }
              this.decodedData = e.createBuffer(n, this.duration);
              _context3.next = 31;
              break;
            case 23:
              if (!t) {
                _context3.next = 31;
                break;
              }
              _context3.next = 26;
              return t.arrayBuffer();
            case 26:
              _i5 = _context3.sent;
              _context3.next = 29;
              return e.decode(_i5, this.options.sampleRate);
            case 29:
              this.decodedData = _context3.sent;
              0 !== this.duration && this.duration !== 1 / 0 || (this.duration = this.decodedData.duration);
            case 31:
              this.emit("decode", this.duration), this.decodedData && this.renderer.render(this.decodedData), this.emit("ready", this.duration);
            case 32:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "zoom",
    value: function zoom(t) {
      if (!this.decodedData) throw new Error("No audio loaded");
      this.renderer.zoom(t), this.emit("zoom", t);
    }
  }, {
    key: "getDecodedData",
    value: function getDecodedData() {
      return this.decodedData;
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return null !== this.duration ? this.duration : _get(_getPrototypeOf(h.prototype), "getDuration", this).call(this);
    }
  }, {
    key: "toggleInteraction",
    value: function toggleInteraction(t) {
      this.options.interact = t;
    }
  }, {
    key: "seekTo",
    value: function seekTo(t) {
      var e = this.getDuration() * t;
      this.setTime(e);
    }
  }, {
    key: "playPause",
    value: function playPause() {
      return t(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.isPlaying() ? this.pause() : this.play());
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "stop",
    value: function stop() {
      this.pause(), this.setTime(0);
    }
  }, {
    key: "skip",
    value: function skip(t) {
      this.setTime(this.getCurrentTime() + t);
    }
  }, {
    key: "empty",
    value: function empty() {
      this.load("", [[0]], .001);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.emit("destroy"), this.plugins.forEach(function (t) {
        return t.destroy();
      }), this.subscriptions.forEach(function (t) {
        return t();
      }), this.timer.destroy(), this.renderer.destroy(), _get(_getPrototypeOf(h.prototype), "destroy", this).call(this);
    }
  }], [{
    key: "create",
    value: function create(t) {
      return new h(t);
    }
  }]);
  return h;
}(n);
export { h as default };